/**
 * Query validation for Space Manage invite history and link joiners.
 *
 * @module schemas/space-invite-history
 */
import { z } from 'zod';
import { SPACE_INVITE_HISTORY_KINDS, SPACE_INVITE_HISTORY_NAME_QUERY_MIN, SPACE_INVITE_HISTORY_PAGE_SIZE, SPACE_INVITE_HISTORY_PAGE_SIZE_MAX, SPACE_INVITE_HISTORY_SORT_DIRS, SPACE_INVITE_HISTORY_SORTS, SPACE_INVITE_HISTORY_STATUSES, SPACE_INVITE_LINK_JOINERS_PAGE_SIZE, } from '../constants/space-invite-history';
export const SpaceInviteHistoryStatusSchema = z.enum(SPACE_INVITE_HISTORY_STATUSES);
export const SpaceInviteHistorySortSchema = z.enum(SPACE_INVITE_HISTORY_SORTS);
export const SpaceInviteHistorySortDirSchema = z.enum(SPACE_INVITE_HISTORY_SORT_DIRS);
function csvOf(allowed) {
    return z
        .string()
        .optional()
        .transform((raw) => {
        if (!raw || raw.trim() === '')
            return [];
        const parts = raw
            .split(',')
            .map((s) => s.trim())
            .filter((s) => allowed.includes(s));
        return [...new Set(parts)];
    });
}
const StatusesCsvSchema = csvOf(SPACE_INVITE_HISTORY_STATUSES);
const KindsCsvSchema = csvOf(SPACE_INVITE_HISTORY_KINDS);
const NameQuerySchema = z
    .string()
    .max(128)
    .optional()
    .transform((raw) => {
    const trimmed = raw?.trim() ?? '';
    return trimmed.length >= SPACE_INVITE_HISTORY_NAME_QUERY_MIN ? trimmed : undefined;
});
export const ListSpaceInviteHistoryQuerySchema = z.object({
    statuses: StatusesCsvSchema,
    kinds: KindsCsvSchema,
    sort: SpaceInviteHistorySortSchema.default('createdAt'),
    dir: SpaceInviteHistorySortDirSchema.default('desc'),
    q: NameQuerySchema,
    limit: z.coerce
        .number()
        .int()
        .min(1)
        .max(SPACE_INVITE_HISTORY_PAGE_SIZE_MAX)
        .default(SPACE_INVITE_HISTORY_PAGE_SIZE),
    offset: z.coerce.number().int().min(0).default(0),
});
export function parseListSpaceInviteHistoryQuery(params) {
    const parsed = ListSpaceInviteHistoryQuerySchema.safeParse({
        ...(params.statuses ? { statuses: params.statuses } : {}),
        ...(params.kinds ? { kinds: params.kinds } : {}),
        ...(params.sort ? { sort: params.sort } : {}),
        ...(params.dir ? { dir: params.dir } : {}),
        ...(params.q ? { q: params.q } : {}),
        ...(params.limit ? { limit: params.limit } : {}),
        ...(params.offset != null && params.offset !== '' ? { offset: params.offset } : {}),
    });
    return parsed.success ? parsed.data : null;
}
export const ListSpaceInviteLinkRedemptionsQuerySchema = z.object({
    q: NameQuerySchema,
    limit: z.coerce
        .number()
        .int()
        .min(1)
        .max(SPACE_INVITE_LINK_JOINERS_PAGE_SIZE)
        .default(SPACE_INVITE_LINK_JOINERS_PAGE_SIZE),
    offset: z.coerce.number().int().min(0).default(0),
});
export function parseListSpaceInviteLinkRedemptionsQuery(params) {
    const parsed = ListSpaceInviteLinkRedemptionsQuerySchema.safeParse({
        ...(params.q ? { q: params.q } : {}),
        ...(params.limit ? { limit: params.limit } : {}),
        ...(params.offset != null && params.offset !== '' ? { offset: params.offset } : {}),
    });
    return parsed.success ? parsed.data : null;
}
//# sourceMappingURL=space-invite-history.js.map